// @flow

import { i18n } from 'shared/utils';
import type { FilterOption } from 'main-app/components/FilterControls';

export default (): Array<FilterOption> => [
  {
    label: i18n.t('Customer'),
    name: 'customerIds',
    type: 'customer',
    multi: true,
  },
  {
    label: i18n.t('Status'),
    name: 'statuses',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Draft'), value: 'DRAFT' },
      { label: i18n.t('Ready'), value: 'READY' },
      { label: i18n.t('Shipped'), value: 'SHIPPED' },
      { label: i18n.t('Delivered'), value: 'DELIVERED' },
    ],
  },
  {
    label: i18n.t('Est. Ship Date'),
    name: 'estimatedShipDate',
    type: 'date-range',
  },
  {
    label: i18n.t('Actual Ship Date'),
    name: 'actualShipDate',
    type: 'date-range',
  },
];
